import staceyPic from "@/public/images/artists/stacey.png";
import { Artist } from "@/types/types";

export const stacey = {
  id: "24",
  name: "Stacey",
  image: staceyPic,
  description: `Introducing "Stacey," your go to singer for EDM. Her expressive vocals effortlessly convey emotions, immersing listeners in relatable stories. Stacey's music captures the essence of youthful authenticity and emotional depth.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Fstacey-preview.mp3",
  meta: {
    free: false,
    new: false,
  },
  filters: {
    gender: "Female",
    tags: {
      primary: ["Dance", "Pop", "Airy"],
      secondary: ["Singer", "Youthful"],
    },
    pitchRange: {
      categories: {
        low: "Mid",
        high: "Mid",
      },
      specific: {
        low: 55,
        high: 72,
      },
    },
  },
} as const satisfies Artist;
